module.exports = __webpack_public_path__ + "static/buildings-e38698dfcbdcfdba7593c203dc0f3b77.svg";